const NotFound = () => <p>Oops! you found a page that does not exist!</p>

NotFound.displayName = 'NotFound'

export default NotFound
